module.exports = __webpack_public_path__ + "img/孙富春.e7e2fafb.jpg";